import moment from 'moment'

export const dateRangeCaption = (from, to) => {
  const format = value => {
    if (!value) return ''
    const parsed = moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY'], true)
    return parsed.isValid() ? parsed.format('D MMM YYYY') : ''
  }
  const start = format(from)
  const end = format(to)
  if (start && end) return `${start} – ${end}`
  return 'All dates'
}
